import type { AlertStatic } from 'react-native';

/**
 * - buttons
 * - onPress만 동작합니다.
 *
 */
export const systemAlert: AlertStatic['alert'] = (title, message, buttons) => {
  const isAlert =
    buttons === undefined || buttons.length === 0 || buttons.length === 1;
  const content = `${title}${message ? `\n\n${message}` : ''}`;

  if (
    buttons !== undefined &&
    buttons.length > 2 &&
    process.env.NODE_ENV === 'development'
  ) {
    console.warn(
      'SystemAlert: 버튼의 수가 세개 이상인 경우 두개까지만 적용됩니다.',
    );
  }

  if (isAlert) {
    window.alert(content);

    if (buttons?.length === 1) {
      const { onPress } = buttons[0];
      onPress?.();
    }
    return;
  }

  const positiveResult = window.confirm(content);
  if (positiveResult) {
    const { onPress } = buttons[1];
    onPress?.();
    return;
  }
  if (!positiveResult) {
    const { onPress } = buttons[0];
    onPress?.();
    return;
  }
};
